import InputForm from '../components/InputForm';

export const validateEmail = (value) => {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(value);
}

export const validateSenha = (value) => {
    return !!value && value.length >= 6 && value.length <= 10;
}

export const validateCPF = (value = '') => {
    const cpf = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    return !!cpf && cpf.length === 11;
}

export function CPFValido(strCPF) {
    var Soma;
    var Resto;
    Soma = 0;
    if ((strCPF === "00000000000") ||
        (strCPF === "11111111111") ||
        (strCPF === "22222222222") ||
        (strCPF === "33333333333") ||
        (strCPF === "44444444444") ||
        (strCPF === "55555555555") ||
        (strCPF === "66666666666") ||
        (strCPF === "77777777777") ||
        (strCPF === "88888888888") ||
        (strCPF === "99999999999")) {
        return false;
    }

    let i = 0;
    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
}

export const limparCNPJAlfanumerico = (valor = '') => {
    return String(valor)
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');
}

const valorCaracterCNPJ = (c) => {
    if (/[0-9]/.test(c)) {
        return parseInt(c, 10);
    }

    return c.charCodeAt(0) - 48;
};

export function CNPJValido(cnpj) {
    cnpj = limparCNPJAlfanumerico(cnpj);

    if (!cnpj || cnpj.length !== 14) {
        return false;
    }

    if (/^([A-Z0-9])\1{13}$/.test(cnpj)) {
        return false;
    }

    const calcularDigito = (base) => {
        let soma = 0;
        let pos = base.length - 7;

        for (let i = base.length; i >= 1; i--) {
            soma += valorCaracterCNPJ(base.charAt(base.length - i)) * pos--;

            if (pos < 2) {
                pos = 9;
            }
        }

        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };

    const base12 = cnpj.substring(0, 12);
    const digito1 = calcularDigito(base12);

    if (digito1 !== parseInt(cnpj.charAt(12), 10)) {
        return false;
    }

    const base13 = cnpj.substring(0, 13);
    const digito2 = calcularDigito(base13);

    if (digito2 !== parseInt(cnpj.charAt(13), 10)) {
        return false;
    }

    return true;
}



export const validateSelect = value => {
    return Boolean(value && value.key);
}

export const checkFormIsValid = (refs) => {
    return Object.keys(refs)
        .map(ref => refs[ref])
        .filter(element => element instanceof InputForm)
        .reduce(((previousValid, input) => {
            return input.isValid() && previousValid;
        }), true)
}



// WEBPACK FOOTER //
// ./src/utils/Validator.js